<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4><span class="font-weight-semibold">Campaign list</span>
                        <button class="btn btn-primary" @click="adding = true">Add</button>
                        <button class="btn btn-primary" @click="addingMultiple = true"
                            v-tooltip="'Lets you create multiple campaign in single action'">Add multiple</button>
                        <button class="btn btn-primary" @click="addingMultiple2 = true"
                            v-tooltip="'Lets you create multiple campaign in single action'">Add multiple #2</button>
                    </h4>
                    <div style="margin-left:10px" class="btn-group">
                        <button class="btn btn-primary disabled" disabled>Download openers for last </button>
                        <button class="btn btn-primary" @click="downloadOpeners($event, 3)">3 days</button>
                        <button class="btn btn-primary" @click="downloadOpeners($event, 7)">7 days</button>
                        <button class="btn btn-primary" @click="downloadOpeners($event, 14)">14 days</button>
                        <button class="btn btn-primary" @click="downloadOpeners($event, 30)">30 days</button>
                        <button class="btn btn-primary" @click="downloadOpeners($event, 60)">60 days</button>
                    </div>
                    <a href="#" class="header-elements-toggle text-default d-md-none"><i class="icon-more"></i></a>
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <div class="table-responsive" :class="{ 'loading-mask': loading }">
                    <button @click="downloadCsv" class="btn btn-primary pull-right" style="margin: 10px">Download
                        CSV</button>
                    <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">Refresh list</button>
                    <button :disabled="page >= pages" @click="offset = (pages - 1) * limit; load()"
                        class="btn btn-primary pull-right" style="margin: 10px">Last page >></button>
                    <button :disabled="page >= pages" @click="nextPage" class="btn btn-primary pull-right"
                        style="margin: 10px">Next page >></button>
                    <button :disabled="true" class="btn btn-primary pull-right" style="margin: 10px">Page: {{ page }} /
                        {{ pages }}</button>
                    <button :disabled="offset <= 0" @click="prevPage" class="btn btn-primary pull-right"
                        style="margin: 10px">
                        << Previous page</button> <button :disabled="offset <= 0" @click="offset = 0; load()"
                                class="btn btn-primary pull-right" style="margin: 10px">
                                << First page</button> <input placeholder="Search by text"
                                        style="border: 1px solid grey; margin-top: 10px" type="text"
                                        class="col-2 form-control pull-right" v-model="query" />
                                    <table class="table table-striped table-xs" style="min-height: 100px">
                                        <thead>
                                            <tr>
                                                <th>No.</th>
                                                <th>Name</th>
                                                <th>Subdomain</th>
                                                <th>Domain</th>
                                                <th>Malier account</th>
                                                <th>Contact list</th>
                                                <th v-tooltip="`
                                        Contact - a number of contacts from contact list<br/>
                                        Suppress - a number of addresses that were suppressed from sending<br/>
                                        `">Counters: contact / suppress / sent / fail / deliver / open / click / spam
                                                    report / unsubscribe (uniques) <i class="icon-info22"></i></th>
                                                <th>Status</th>
                                                <th>Throttling</th>
                                                <th>Scheduled at (EST)</th>
                                                <th>Created at (EST)</th>
                                                <th>Completed at (EST)</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="r, k in rows">
                                                <td style="width:10px">{{ k + 1 }}</td>
                                                <td
                                                    v-tooltip="`Tag: ` + (r.tag || `-`) + `, contact list tag: ` + (r.contact_list_tag || `-`)">
                                                    {{ r.name }} <i class="icon-info22"></i></td>
                                                <td>{{ r.subdomain }}</td>
                                                <td>{{ r.domain && r.domain.domain || 'missing!' }}</td>
                                                <td>{{ r.mailer_account && r.mailer_account.name || 'missing!' }}</td>
                                                <td>{{ r.list && r.list.name || 'missing' }}</td>
                                                <td>
                                                    <template v-if="r.initialized">
                                                        <span v-tooltip="JSON.stringify(r.counters)">
                                                            {{ r.counters.contact }} /
                                                            {{ r.counters.suppressed }} /
                                                            {{ r.counters.sent }} /
                                                            {{ r.counters.failed }} /
                                                            {{ r.counters.delivered }} /
                                                            {{ r.counters.opened }} /
                                                            {{ r.counters.clicked }} /
                                                            {{ r.counters.spam }} /
                                                            {{ r.counters.unsubscribed }}
                                                        </span>
                                                    </template>
                                                </td>
                                                <td><span class="badge" :class="statusClass(r.status)">{{ r.status
                                                        }}
                                                        <i v-if="r.status === 'automated'"
                                                            v-tooltip="'This campaign has been created automatically'"
                                                            class="icon-info22"></i>
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="r.send_limit <= 0" class="badge badge-dark">n/a</span>
                                                    <span v-else class="badge badge-warning">{{ r.send_limit }} msgs /
                                                        hour</span>
                                                </td>
                                                <td>
                                                    <template v-if="r.scheduled_at">{{ r.scheduled_at | estTime
                                                        }}</template>
                                                </td>
                                                <td>{{ r.created_at | estTime }}</td>
                                                <td>
                                                    <template v-if="r.completed_at">
                                                        {{ r.completed_at | estTime }}
                                                    </template>
                                                </td>
                                                <td>
                                                    <button v-tooltip="'Starts sending the campaign'"
                                                        v-if="['paused'].indexOf(r.status) >= 0"
                                                        @click="setStatus($event, r._id, 'running')"
                                                        class="btn btn-primary">Start</button>
                                                    <button v-tooltip="'Stops sending the campaign (can be resumed)'"
                                                        v-if="['running', 'scheduled'].indexOf(r.status) >= 0"
                                                        @click="setStatus($event, r._id, 'paused')"
                                                        class="btn btn-danger">Stop</button>
                                                    <button v-if="['new', 'scheduled', 'paused'].indexOf(r.status) >= 0"
                                                        @click="adding = r._id"
                                                        class="btn btn-sm btn-primary">Edit</button>
                                                    <button v-if="r.status != 'automated'"
                                                        v-tooltip="'Opens a modal window with data filled from particular campaign'"
                                                        @click="adding = 'clone_' + r._id"
                                                        class="btn btn-sm btn-primary">Clone</button>
                                                    <button
                                                        v-tooltip="'Downloads CSV containing addresses that opened or/and clicked'"
                                                        @click="downloadCampaignCsv($event, r._id)"
                                                        class="btn btn-sm btn-primary">Download CSV</button>
                                                </td>
                                            </tr>
                                            <h2 v-if="rows.length === 0"> </h2>
                                        </tbody>
                                    </table>
                </div>
            </div>
        </div>
        <!-- /content area -->
        <campaign v-if="adding" :id="adding" @close="adding = false" @reload="load()" />
        <multiple-campaign-creator v-if="addingMultiple" @close="addingMultiple = false" @reload="load()" />
        <multiple-campaign-creator2 v-if="addingMultiple2" @close="addingMultiple2 = false" @reload="load()" />
        <!-- /content area -->
    </div>
</template>
<script>
let queryDebounce
import moment from 'moment'
import EventBus from '@/event_bus'
import Campaign from './modal/Campaign.vue'
import MultipleCampaignCreator from './modal/MultipleCampaignCreator.vue'
import MultipleCampaignCreator2 from './modal/MultipleCampaignCreator2.vue'
export default {
    components: { Campaign, MultipleCampaignCreator, MultipleCampaignCreator2 },
    data() {
        return {
            rows: [],
            loading: true,
            adding: false,
            addingMultiple: false,
            addingMultiple2: false,
            limit: 25,
            offset: 0,
            count: 0,
            query: null
        }
    },
    watch: {
        query() {

            if (queryDebounce) {
                clearTimeout(queryDebounce)
            }

            queryDebounce = setTimeout(() => {
                this.offset = 0
                this.load()
            }, 500)
        },
    },
    filters: {
        estTime(d) {
            return moment(d).utcOffset(-5 * 60).format('DD-MM-YY HH:mm')
        }
    },
    computed: {
        pages() {
            if (this.count <= this.limit) {
                return 1
            }
            return Math.ceil(this.count / this.limit)
        },
        page() {
            if (this.offset === 0) {
                return 1
            }
            return (this.offset / this.limit) + 1 || 1
        },
    },
    methods: {
        downloadOpeners(_, days) {
            this.$confirm({ message: `Download openers for last ${days} days` }).then(() => {
                let u = this.$api.getUrl() + 'campaign/openers/' + days + '/download/csv'
                window.open(u)
                this.$notify.addWarning('Generating CSV please wait...')
            })
        },
        downloadCampaignCsv(_, id) {
            this.$confirm({ message: 'Confirm CSV export' }).then(() => {

                let u = this.$api.getUrl() + 'campaign/' + id + '/download/csv'

                window.open(u)
                this.$notify.addWarning('Generating CSV please wait...')
            })
        },
        downloadCsv() {
            this.$confirm({ message: 'Confirm CSV export' }).then(() => {

                let u = this.$api.getUrl() + 'campaign/download/csv'

                window.open(u)
                this.$notify.addWarning('Generating CSV please wait...')
            })
        },
        setStatus(_, id, status) {
            this.$confirm().then(() => {
                this.$api.postReq(`campaign/${id}/status`, {
                    status
                }).then(() => {
                    this.load()
                })

            })
        },
        statusClass: function (status) {
            switch (status) {
                case 'running':
                    return 'badge-danger'
                case 'paused':
                    return 'badge-dark'
                case 'scheduled':
                    return 'badge-primary'
                case 'automated':
                    return 'badge-warning'
                case 'completed':
                    return 'badge-success'
            }
        },
        prevPage() {
            this.offset -= 25
            this.load()
        },
        nextPage() {
            this.offset += 25
            this.load()

        },
        load() {
            this.$api.getReq(`campaign`, {
                limit: this.limit,
                offset: this.offset,
                query: this.query || ''
            }).then(res => {
                this.rows = res.body.data
                this.count = res.body.count
                this.loading = false
            })
        }
    },
    destroyed() { },
    mounted() {
        this.load()
    }
}
</script>
<style>
.avsquare {
    width: 7px;
    height: 100%;
    float: left;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, .1);
}

.avsquare:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.avsquare:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

tbody .btn {
    padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/CampaignList.vue